import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Grid } from "@/comn/components";
import { comnUtils, comnEnvs } from "@/comn/utils"; // 프로젝트 공통 유틸
import { Page, Group, Layout, Button, FormControl } from "@/comn/components"; // 화면 구성 컴포넌트
import { useFetch, useForm, useGrid, useStore, useToast, useResource, useModal, usePage, usePopup } from "@/comn/hooks";
import { BASE, URLS, APIS, SF_NOTI_INFO } from "@/tra/tancis/ptli/ptl/noti/services/PtliNotiService";

/*
 * Notifice Registration
 * !== 알림 등록 ==!
 */
export const PTLI1010002S = (): JSX.Element => {
    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0025", "auth_ptli0001", "auth_ptli0015", "auth_ptlianyADM"],
    });
    const { t } = useTranslation();
    const navigate = useNavigate();
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { openPopup } = usePopup();
    const { pgeStore, setStore, getStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast();

    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "CGM0176" },
            { area: "comnCd", comnCd: "COM0024" },
            { area: "comnCd", comnCd: "PTL0020" },
        ],
    });

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Notifice Information !== 알림 정보 ==!
        notiInfo: useForm({
            defaultSchema: SF_NOTI_INFO,
            defaultValues: {
                rcveNtfcRqrdYn: "Y",
                useYn: "Y",
            },
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // Create Notifice !== 알림 등록 ==!
        createNoti: useFetch({
            api: (data) => APIS.createNoti({ ...data }),
            onSuccess: () => {
                modal.openModal({
                    content: "msg.com.00062", // Successfully saved., !== 정상적으로 저장되었습니다. ==!
                    onConfirm: () => {
                        navigate(URLS.ptli1010001q);
                    },
                    onCancel: () => {
                        navigate(URLS.ptli1010001q);
                    },
                });
            },
            onError: (error) => {
                console.log(error);
                if (error.response.status === 400) {
                    console.log(error.response.data);
                    form.notiInfo.setErrors(error.response.data.errors);
                }

                modal.openModal({
                    content: "msg.00006",
                });
            },
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        // on Save Button Click Event Handler  !== 알림 등록 ==!
        onSaveBtnClick: () => {
            if (!comnUtils.isEmpty(form.notiInfo.errors)) {
                toast.showToast({ type: "warning", content: "msg.00002" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                return;
            }
            form.notiInfo.handleSubmit(
                () => {
                    const data = form.notiInfo.getValues();
                    modal.openModal({
                        content: "msg.00101", // Do you want to save ? !== 저장 하시겠습니까 ? ==!
                        onConfirm: () => {
                            fetch.createNoti.fetch(data);
                        },
                    });
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.00002" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                },
            )();
        },
    };

    useEffect(() => {
        form.notiInfo.setFocus("inexTpCd");
    }, []);

    return (
        <Page>
            <form>
                <Group>
                    <Group.Body>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.notiInfo.schema.inexTpCd}></Group.Control>
                                <Group.Control {...form.notiInfo.schema.notiId}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.notiInfo.schema.bsopClsfCd}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.notiInfo.schema.notiTpSettValueList}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.notiInfo.schema.notiNm}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.notiInfo.schema.notiMsgEngCn}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.notiInfo.schema.notiMsgTzCn}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.notiInfo.schema.rcveNtfcRqrdYn}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.notiInfo.schema.sndrNm}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.notiInfo.schema.sndrEmlAddr}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.notiInfo.schema.sndrTelno}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.notiInfo.schema.useYn}></Group.Control>
                            </Group.Row>
                        </Group.Section>
                    </Group.Body>
                </Group>
            </form>
            <Layout direction="row">
                <Layout.Left>
                    <Button
                        role="list"
                        onClick={() => {
                            navigate(URLS.ptli1010001q);
                        }}
                    ></Button>
                </Layout.Left>
                <Layout.Right>
                    <Button
                        role="save"
                        onClick={() => {
                            handler.onSaveBtnClick();
                        }}
                    ></Button>
                </Layout.Right>
            </Layout>
        </Page>
    );
};
